import { useIsDarkMode } from "@fe/hooks/use-is-dark-mode";
import type { PropsWithChildren } from "react";
import { useLayoutEffect } from "react";

export const AppThemeProvider = ({ children }: PropsWithChildren) => {
	const isDarkMode = useIsDarkMode();

	useLayoutEffect(() => {
		document.documentElement.classList.toggle("dark", isDarkMode);
	}, [isDarkMode]);

	return <>{children}</>;
};
